import { TeacherListType, TeacherEditType } from '@/models/teacherListModel'
import { PaginationStatus } from '@/models/paginationModel'
import { ApiResponseManagerList, ApiResponseManagerEditData } from '@/models/apiResponses/managers'
import { UserRoles, UserRoleSettings } from '@/const/UserRoles'

export class TeacherManagementUtils {
  /**
   * APIレスポンスを先生一覧情報に変換する
   * @param apiResponse 管理者ユーザー一覧APIレスポンス
   * @returns 先生一覧情報
   */
  public static formatTeacherDatas(apiResponse: ApiResponseManagerList): TeacherListType[] {
    if (!apiResponse) return []

    return apiResponse.responses.map((response) => {
      return {
        userId: response.id,
        userName: response.nickname,
        bcbtCode: response.bcbtCode,
        academyName: response.academyName,
        branchName: response.branchName,
        roleName: UserRoleSettings.findByRole(response.role)?.name || '',
      }
    })
  }

  /**
   * APIレスポンスからページネーションの状態を取得
   * @param apiResponse 管理者ユーザー一覧APIレスポンス
   * @returns ページネーション情報
   */
  public static getPagenationStatus(apiResponse: ApiResponseManagerList): PaginationStatus | null {
    if (!apiResponse) return null

    return apiResponse.pagination
  }

  /**
   * システム管理者権限画面で使用する先生編集情報を生成する
   * @param apiResponse 管理者ユーザー情報取得APIレスポンス
   * @returns 先生編集情報
   */
  public static buildAdminTeacherEditData(apiResponse?: ApiResponseManagerEditData): TeacherEditType {
    // APIレスポンスが渡されない場合は新規登録用の情報をセット
    if (!apiResponse) {
      return {
        role: UserRoles.ADMIN,
        academyId: '',
        branchId: '',
        userName: '',
        bcbtCode: '',
        password: '',
        passwordConfirm: '',
      }
    }

    return {
      userId: apiResponse.id,
      role: apiResponse.role,
      academyId: String(apiResponse.academyId),
      branchId: String(apiResponse.branchId),
      userName: apiResponse.userName,
      bcbtCode: apiResponse.bcbtCode,
      password: '',
      passwordConfirm: '',
    }
  }

  /**
   * 塾管理者権限画面で使用する先生編集情報を生成する
   * @param apiResponse 管理者ユーザー情報取得APIレスポンス
   * @returns 先生編集情報
   */
  public static buildAcademyTeacherEditData(apiResponse?: ApiResponseManagerEditData): TeacherEditType {
    // APIレスポンスが渡されない場合は新規登録用の情報をセット
    if (!apiResponse) {
      return {
        role: UserRoles.ACADEMY,
        branchId: '',
        userName: '',
        bcbtCode: '',
        password: '',
        passwordConfirm: '',
      }
    }

    return {
      userId: apiResponse.id,
      role: apiResponse.role,
      branchId: String(apiResponse.branchId),
      userName: apiResponse.userName,
      bcbtCode: apiResponse.bcbtCode,
      password: '',
      passwordConfirm: '',
    }
  }

  /**
   * 教室長・講師権限画面で使用する先生編集情報を生成する
   * @param apiResponse 管理者ユーザー情報取得APIレスポンス
   * @returns 先生編集情報
   */
  public static buildBranchTeacherEditData(apiResponse?: ApiResponseManagerEditData): TeacherEditType {
    // APIレスポンスが渡されない場合は新規登録用の情報をセット
    if (!apiResponse) {
      return {
        role: UserRoles.TEACHER,
        userName: '',
        bcbtCode: '',
        password: '',
        passwordConfirm: '',
      }
    }

    return {
      userId: apiResponse.id,
      role: apiResponse.role,
      userName: apiResponse.userName,
      bcbtCode: apiResponse.bcbtCode,
      password: '',
      passwordConfirm: '',
    }
  }
}
